import {register, CloudObject, defineProperty, Color} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class CartesianConfig extends CloudObject {
    static DEFAULT_INSTANCE_TAG = '018d83c7fd86287c7b13'


    /**
     *
     * @param prop
     * @returns {unknown}
     */
    getPropIfExists(prop) {
        return this.get(prop) ?? CloudObject.get(CartesianConfig.DEFAULT_INSTANCE_TAG).get(prop);
    }

    /**
     * @return {string}
     */
    getName() {
        return this.getPropIfExists(CartesianConfig.nameProp);
    }

    /**
     * @return {string}
     */
    getXPath() {
        return this.getPropIfExists(CartesianConfig.xPathProp);
    }

    /**
     * @return {string}
     */
    getYPath() {
        return this.getPropIfExists(CartesianConfig.yPathProp);
    }

    /**
     * @return {string}
     */
    getRPath() {
        return this.getPropIfExists(CartesianConfig.rPathProp);
    }

    /**
     * @return {string}
     */
    getAxis() {
        return this.getPropIfExists(CartesianConfig.axisProp);
    }

    /**
     * @return {string}
     */
    getType() {
        return this.getPropIfExists(CartesianConfig.typeProp);
    }

    /**
     * @return {number}
     */
    getOrder() {
        return this.getPropIfExists(CartesianConfig.orderProp);
    }

    /**
     * @return {string}
     */
    getColorPath() {
        return this.getPropIfExists(CartesianConfig.colorPathProp);
    }

    /**
     * @return {string}
     */
    getLegend() {
        return this.getPropIfExists(CartesianConfig.legendProp);
    }

    /**
     * @return {Color}
     */
    getColor() {
        return this.getPropIfExists(CartesianConfig.colorProp);
    }

    /**
     * @return {boolean}
     */
    getDisplayDataLabels() {
        return this.getPropIfExists(CartesianConfig.displayDataLabels);
    }

    /**
     * @return {string}
     */
    getConfigJSON() {
        return this.getPropIfExists(CartesianConfig.configJSONProp);
    }

}

// Hardcoded tags
register('018d3057fd26709b9685', CartesianConfig);
CartesianConfig.nameProp = defineProperty('018d7898ac2778bf7ef7');
CartesianConfig.axisProp = defineProperty('018d6972810742c33659');
CartesianConfig.typeProp = defineProperty('018d305923879d1e4349');
CartesianConfig.orderProp = defineProperty('018d3059695ec27d19ce');
CartesianConfig.xPathProp = defineProperty('018d3059886e4a4b0bd0');
CartesianConfig.yPathProp = defineProperty('018d305996712f4daf27');
CartesianConfig.rPathProp = defineProperty('018d7e857e99f3aa2a6d');
CartesianConfig.colorPathProp = defineProperty('018d3059bef45490bcb2');
CartesianConfig.legendProp = defineProperty('018d3059eed173a05995');
CartesianConfig.colorProp = defineProperty('018d305a0a6b9ceff9b1');
CartesianConfig.displayDataLabels = defineProperty('018d7f1238ef3bdbac61');
CartesianConfig.configJSONProp = defineProperty('018d305b6e323b35ec27');
